export default __webpack_public_path__ + "static/media/Killer Rhino.0dfcf479.jpg";